import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import AdvancedAlertsPage, { getDefaultPageUI } from "components/pages/AdvancedAlertsPage";
import ManageAlertsContent from "components/pages/AdvancedAlertsPage/components/ManageAlertsContent";
import Classes from "model";

export default function CaptureNotifiLegacyManageAlerts(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    // Sets the component to be used for the content
    .update([ "content" ], ManageAlertsContent)
    .submit();
    
    return <AdvancedAlertsPage ui={ ui } />
}